module.exports = __webpack_public_path__ + "7378230cc759cc8056421abc801fb054.png";